import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, IconButton, MenuItem, Select, Tab, Tabs, withStyles } from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import axios from 'axios';

import { WEB_API } from '../common/Constants';
import Container from '../component/div/Container';

import './Project.css';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" id={`scrollable-prevent-tabpanel-${index}`} aria-labelledby={`scrollable-prevent-tab-${index}`} {...other}>
      {<Box p={3}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const styles = (theme) => ({
  background: {
    backgroundImage: `url('images/background/project_bg.png')`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    width: '100%',
    height: '100%',
  },
  webContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    margin: '0 11%',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  mobileContainer: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      height: '100%',
      padding: theme.spacing(4),
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: 0,
    },
  },

  directionButton: {
    backgroundColor: '#595656',
    opacity: 0.5,
    '& svg': {
      color: '#fff',
    },
    [theme.breakpoints.down('sm')]: {
      backgroundColor: 'transparent',
      opacity: 1,
      '& svg': {
        color: 'rgba(0,0,0,0.5)',
      },
    },
  },

  //탭 영역 - Web
  tabArea: {
    width: '100%',
    padding: theme.spacing(3),
  },
  tabIndicator: {
    display: 'none',
  },
  selectedTab: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    opacity: 1,
    minWidth: '20%',
  },
  notSelectedTab: {
    backgroundColor: '#fcfcfc',
    color: '#565656',
    opacity: 1,
    minWidth: '20%',
  },
  tabButtonText: {
    height: '100%',
    '& div': {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '1em',
    },
    [theme.breakpoints.down('md')]: {
      '& div': {
        fontSize: '0.85em',
      },
    },
  },
  tabPanel: {
    backgroundColor: '#fff',
    // height: '424px',
    height: '55vh',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  tabOtherPanelImage: {
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    border: '1px solid #eeeeee',
    height: '180px',
    cursor: 'pointer',
    '&:hover': {
      '& > div': {
        visibility: 'visible',
      },
    },
    '& > div': {
      visibility: 'hidden',
    },
  },
  tabDesignPanelImage: {
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    border: '1px solid #eeeeee',
    height: '300px',
    cursor: 'pointer',
    '& > div': {
      visibility: 'hidden',
    },
    '&:hover': {
      '& > div': {
        visibility: 'visible',
      },
    },
  },
  tabPanelText: {
    backgroundColor: 'rgba(0,0,0,0.8)',
    height: '100%',
    color: '#fff',
    padding: '0 1em',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },

  //탭 영역 - Mobile
  mobileTabRoot: {
    backgroundColor: '#fff',
    borderRadius: 0,
    borderStyle: 'none',
    borderColor: 'unset',
    paddingLeft: theme.spacing(4),
    textAlign: 'center',
    '& fieldset': {
      borderStyle: 'none',
      borderColor: 'transperant',
    },
  },
  mobileTabSelect: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    '&:focus': {
      backgroundColor: '#fff',
    },
  },
  mobileTabPanel: {
    backgroundColor: '#fff',
    marginTop: theme.spacing(1),
    // height: '500px',
    overflow: 'hidden auto',
    padding: theme.spacing(1, 0),
  },
  mobileTabContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  mobileTabOtherPanelImage: {
    backgroundSize: '100%',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundBlendMode: 'multiply',
    border: '1px solid #eeeeee',
    height: '100px',
    color: '#fff',
    overflow: 'hidden',
    '&:hover': {
      '& > div': {
        visibility: 'visible',
      },
    },
    '& > div': {
      visibility: 'hidden',
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      color: '#fff',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      padding: '0 1em',
    },
  },
  mobileTabDesignPanelImage: {
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    border: '1px solid #eeeeee',
    height: '200px',
    '&:hover': {
      '& > div': {
        visibility: 'visible',
      },
    },
    '& > div': {
      visibility: 'hidden',
    },
  },
});

const TABS_ARR = ['ALL', 'Pharmaceutical', 'Medical Society', 'Non Medical', 'Creative Design'];

class Project extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tabValue: 0,
    };

    this.refTopbar = React.createRef();

    this.refMobileTab = React.createRef();
    this.refMobileTabPanel = React.createRef();
  }

  componentDidMount() {
    this.getProjectList();

    // let footer = document.getElementById('footer');
    // footer.style.position = 'static';
    if (sessionStorage.getItem('isTopbarClick') === 'true' && this.props.match.params.id) {
      this.setState({ tabValue: Number(this.props.match.params.id) });
    }

    this.refMobileTabPanel.current.style.height = `calc(100% - ${this.refMobileTab.current.scrollHeight}px - 8px)`;
  }

  componentDidUpdate(prevProps) {
    if (
      sessionStorage.getItem('isTopbarClick') === 'true' &&
      this.props.match.params.id &&
      Number(this.props.match.params.id) !== this.state.tabValue
    ) {
      this.setState({
        tabValue: Number(this.props.match.params.id),
      });
    }
  }

  getProjectList() {
    let all = [];
    let pharmaceutical = [];
    let medicalSociety = [];
    let nonMedical = [];
    let creativeDesign = [];

    axios
      .get(`${WEB_API}/home/project/list`, {
        headers: {
          Pragma: 'no-cache',
        },
      })
      .then((res) => {
        all = res.data.Items.sort(function (a, b) {
          // let aCate = a.sortOrder.substr(0, 1);
          // let bCate = b.sortOrder.substr(0, 1);
          // let aOrder = Number(a.sortOrder.substr(1));
          // let bOrder = Number(b.sortOrder.substr(1));
          // if (aCate < bCate) return -1;
          // if (aCate > bCate) return 1;
          // if (aOrder < bOrder) return -1;
          // if (aOrder > bOrder) return 1;

          // [수정 231211] 전체카테고리는 createdAt 으로 sorting
          let aCreatedAt = Number(a.createdAt);
          let bCreatedAt = Number(b.createdAt);

          if (bCreatedAt < aCreatedAt) return -1;
          if (bCreatedAt > aCreatedAt) return 1;

          return 0;
        });

        // [수정 231211] 개별카테고리는 sortOrder 역순 (숫자 클수록 최신)
        pharmaceutical = res.data.Items.filter((item) => item.category === 'Pharmaceutical').sort((a, b) => {
          let aOrder = Number(a.sortOrder.substr(1));
          let bOrder = Number(b.sortOrder.substr(1));
          return bOrder - aOrder;
          // return aOrder < bOrder ? -1 : aOrder < bOrder ? 1 : 0;
        });
        medicalSociety = res.data.Items.filter((item) => item.category === 'MedicalSociety').sort((a, b) => {
          let aOrder = Number(a.sortOrder.substr(1));
          let bOrder = Number(b.sortOrder.substr(1));
          return bOrder - aOrder;
        });
        nonMedical = res.data.Items.filter((item) => item.category === 'NoneMedical').sort((a, b) => {
          let aOrder = Number(a.sortOrder.substr(1));
          let bOrder = Number(b.sortOrder.substr(1));
          return bOrder - aOrder;
        });
        creativeDesign = res.data.Items.filter((item) => item.category === 'CreativeDesign').sort((a, b) => {
          let aOrder = Number(a.sortOrder.substr(1));
          let bOrder = Number(b.sortOrder.substr(1));
          return bOrder - aOrder;
        });

        this.setState({ all, pharmaceutical, medicalSociety, nonMedical, creativeDesign });
      });
  }

  handleState(key, value) {
    this.setState({ [key]: value });
  }

  handleTab(val) {
    this.setState({ tabValue: val });
    sessionStorage.setItem('isTabClick', true);
    sessionStorage.setItem('isTopbarClick', false);
  }

  moveTab(direction) {
    if (direction === 'left') {
      this.setState((prevState) => ({
        tabValue: Number(prevState.tabValue) > 0 ? Number(prevState.tabValue) - 1 : TABS_ARR.length - 1,
      }));
      sessionStorage.setItem('isTabClick', true);
      sessionStorage.setItem('isTopbarClick', false);
    } else {
      this.setState((prevState) => ({
        tabValue: Number(prevState.tabValue) < TABS_ARR.length - 1 ? Number(prevState.tabValue) + 1 : 0,
      }));
      sessionStorage.setItem('isTabClick', true);
      sessionStorage.setItem('isTopbarClick', false);
    }
  }

  renderTabPanel() {
    const { classes } = this.props;
    const { tabValue, all, pharmaceutical, medicalSociety, nonMedical, creativeDesign } = this.state;

    if (tabValue === 0) {
      return (
        <TabPanel value={tabValue} className={classes.tabPanel} index={tabValue}>
          {this.renderOtherTabPanel(all)}
        </TabPanel>
      );
    } else if (tabValue === 1) {
      return (
        <TabPanel value={tabValue} className={classes.tabPanel} index={tabValue}>
          {this.renderOtherTabPanel(pharmaceutical)}
        </TabPanel>
      );
    } else if (tabValue === 2) {
      return (
        <TabPanel value={tabValue} className={classes.tabPanel} index={tabValue}>
          {this.renderOtherTabPanel(medicalSociety)}
        </TabPanel>
      );
    } else if (tabValue === 3) {
      return (
        <TabPanel value={tabValue} className={classes.tabPanel} index={tabValue}>
          {this.renderOtherTabPanel(nonMedical)}
        </TabPanel>
      );
    } else if (tabValue === 4) {
      return (
        <TabPanel value={tabValue} className={classes.tabPanel} index={tabValue}>
          <Grid container spacing={2}>
            {this.renderDesignTabPanel(creativeDesign)}
          </Grid>
        </TabPanel>
      );
    }
  }

  renderOtherTabPanel(category) {
    return (
      <Grid container spacing={2}>
        {category &&
          category.map((prj, idx) => (
            <Grid item xs={3} key={`tab-panel-${idx}`} style={{ position: 'relative' }}>
              <div
                className={this.props.classes.tabOtherPanelImage}
                style={{
                  backgroundImage: `url('${prj.logo.path}')`,
                }}
              >
                <div className={this.props.classes.tabPanelText}>
                  <p style={{ fontWeight: 'bold', marginBottom: '0.5em' }}>{prj.title}</p>
                  {/* <p style={{ fontWeight: 'bold', marginBottom: '0.5em' }}>{prj.sortOrder}</p> */}
                  {/* <p style={{ whiteSpace: 'pre-line' }}>{prj.memo}</p> */}
                  {prj.memo &&
                    prj.memo.split('\n').length > 0 &&
                    prj.memo.split('\n').map(
                      (item, index) =>
                        index < 6 && (
                          <p style={{ whiteSpace: 'pre-line' }} key={`desc-${index}`}>
                            {item}
                          </p>
                        ),
                    )}
                </div>
              </div>
            </Grid>
          ))}
      </Grid>
    );
  }

  renderDesignTabPanel(category) {
    return (
      category &&
      category.map((item, idx) => (
        <Grid item xs={6} key={`creative-design-${idx}`}>
          <div
            className={this.props.classes.tabDesignPanelImage}
            style={{
              backgroundImage: `url(${item.logo.path})`,
            }}
          >
            <div className={this.props.classes.tabPanelText}>
              <p style={{ fontWeight: 'bold', marginBottom: '0.5em' }}>{item.title}</p>
              <p style={{ whiteSpace: 'pre-line' }}>{item.memo}</p>
            </div>
          </div>
        </Grid>
      ))
    );
  }

  renderTabPanelMobile() {
    const { tabValue, all, pharmaceutical, medicalSociety, nonMedical, creativeDesign } = this.state;

    if (tabValue === 0) {
      return this.renderOtherTabPanelMobile(all);
    } else if (tabValue === 1) {
      return this.renderOtherTabPanelMobile(pharmaceutical);
    } else if (tabValue === 2) {
      return this.renderOtherTabPanelMobile(medicalSociety);
    } else if (tabValue === 3) {
      return this.renderOtherTabPanelMobile(nonMedical);
    } else if (tabValue === 4) {
      return this.renderDesignTabPanelMobile(creativeDesign);
    }
  }

  renderOtherTabPanelMobile(category) {
    return (
      <Grid container spacing={2}>
        {category &&
          category.map((prj, idx) => (
            <Grid item xs={12} key={`tab-panel-mobile-${idx}`}>
              <div
                className={this.props.classes.mobileTabOtherPanelImage}
                style={
                  {
                    // backgroundImage: `url('${prj.logo.path}')`,
                  }
                }
              >
                <div>
                  <p style={{ fontWeight: 'bold', marginBottom: '0.5em' }}>{prj.title}</p>
                  {category?.length}
                  {/* <p style={{ whiteSpace: 'pre-line' }}>{prj.memo}</p> */}
                  {prj.memo &&
                    prj.memo.split('\n').length > 0 &&
                    prj.memo.split('\n').map(
                      (item, index) =>
                        index < 2 && (
                          <p style={{ whiteSpace: 'pre-line' }} key={`desc-${index}`}>
                            {item}
                          </p>
                        ),
                    )}
                </div>
                {/* <div dangerouslySetInnerHTML={{ __html: prj.title }} /> */}
              </div>
            </Grid>
          ))}
      </Grid>
    );
  }

  renderDesignTabPanelMobile(category) {
    return (
      <Grid container direction="column" justify="center" spacing={2}>
        {category &&
          category.map((prj, idx) => (
            <Grid item xs={12} key={`tab-design-panel-${idx}`}>
              <div
                className={this.props.classes.mobileTabDesignPanelImage}
                style={{
                  backgroundImage: `url(${prj.logo.path})`,
                }}
              >
                <div
                  style={{
                    backgroundColor: 'rgba(0,0,0,0.8)',
                    height: '100%',
                    color: '#fff',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                  }}
                  // dangerouslySetInnerHTML={{ __html: prj.title }}
                >
                  <div>
                    <p style={{ fontWeight: 'bold', marginBottom: '0.5em' }}>{prj.title}</p>
                    <p style={{ whiteSpace: 'pre-line' }}>{prj.memo}</p>
                  </div>
                </div>
              </div>
            </Grid>
          ))}
      </Grid>
    );
  }

  render() {
    const { classes } = this.props;
    const { tabValue } = this.state;

    return (
      <Container currentPath={this.props.location.pathname} ref={this.refTopbar}>
        <div className={classes.background}>
          <div className={classes.webContainer}>
            <IconButton className={classes.directionButton} onClick={() => this.moveTab('left')}>
              <ChevronLeftIcon />
            </IconButton>

            <div className={classes.tabArea}>
              <Tabs
                variant={'fullWidth'}
                value={tabValue}
                onChange={(e, val) => this.handleTab(val)}
                classes={{
                  indicator: classes.tabIndicator,
                }}
              >
                {TABS_ARR.map((tab, idx) => (
                  <Tab
                    label={<div>{tab}</div>}
                    // value={idx}
                    key={`tab-${idx}`}
                    classes={{
                      root: tabValue === idx ? `${classes.selectedTab}` : `${classes.notSelectedTab}`,
                      wrapper: classes.tabButtonText,
                    }}
                    className={tabValue === idx ? `${classes.selectedTab}` : `${classes.notSelectedTab}`}
                  />
                ))}
              </Tabs>
              {this.renderTabPanel()}
            </div>

            <IconButton className={classes.directionButton} onClick={() => this.moveTab('right')}>
              <ChevronRightIcon />
            </IconButton>
          </div>

          <div className={classes.mobileContainer}>
            <Select
              fullWidth
              variant="outlined"
              value={tabValue}
              onChange={(e) => this.handleTab(e.target.value)}
              classes={{
                root: classes.mobileTabRoot,
                select: classes.mobileTabSelect,
              }}
              ref={this.refMobileTab}
            >
              {TABS_ARR.map((tab, idx) => (
                <MenuItem value={idx} key={`mobile-tab-${idx}`}>
                  {tab}
                </MenuItem>
              ))}
            </Select>
            <div className={classes.mobileTabPanel} ref={this.refMobileTabPanel}>
              {/* 페이지영역 */}
              <div className={classes.mobileTabContent}>
                {/* 내용 */}
                <div style={{ width: '100%', padding: '0 2%' }}>{this.renderTabPanelMobile()}</div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Project);
